import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'mea-page-description-card',
    templateUrl: 'page-description-card.component.html',
    styleUrls: ['./page-description-card.component.scss'],
    standalone: false
})
export class PageDescriptionCardComponent implements OnInit {
    @Input() cardHeadline: string;
    @Input() cardTitle: string;
    @Input() cardLinkUrl: string;
    @Input() cardLinkText: string;
    isHome = this.route.snapshot.params.category === 'home';

    constructor(private route: ActivatedRoute) {}
    ngOnInit(): void {}
}
